import { useEffect } from "react";
import { useEditItem2 } from "../../../api/useNewItem"
import { createSelectSchema, Schema } from "../../../hooks/useSchema";
import { useCRMContext } from "../CRMContext";
import { useCRMGeoContext } from "../CRMGeoContext";
import { apiFetch } from "../../../api/core";

export interface UnifyGeoParams {
  field: "geo_city" | "geo_country";
  old_values: string[];
  target_value?: string | null;
}

export const UnifyGeoParamsSchema: Schema = {
  field: createSelectSchema([
      { value: "geo_country", label: "Страна" },
      { value: "geo_city", label: "Город" }
    ], { label: "Поле"}),
  old_values: { 
    label: "Что переименовать",
  },
  target_value: { 
    label: "Во что переименовать",
  }
};

export const useUnifyContactsGeoNames = (onComplete?: () => void) => {
  const ctx = useCRMContext();

  const data = useEditItem2<UnifyGeoParams>({
    save: async (item) => {
      await apiFetch<{}>(`${ctx.apiPath}/contact/unify-geo`, "post", item);
      if(onComplete) {
        onComplete();
      }
      return item;
    },
    onChange: (o,c) => {
      console.log("OPX", o,c)
      if(c.field && c.field !== o.field) {
        return { ...c, old_values: [], target_value: "" };
      }
      return c;
    },
  })

  const geoCtx = useCRMGeoContext();

  useEffect(() => {
    if(data.dialog.isOpen) {
      geoCtx.ensureLoaded();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.dialog.isOpen]);

  return {
    ...data,
    start: () => data.startEditing({ field: "geo_country", old_values: [], target_value: "" }),
    schema: UnifyGeoParamsSchema,
  }
}

export type UnifyGeoNamesData = ReturnType<typeof useUnifyContactsGeoNames>;
